<template>
    <Layout style="height: 100%" class="main">
        <Sider hide-trigger collapsible :width="256" :collapsed-width="64" v-model="collapsed" class="left-sider"
               :style="{overflow: 'hidden'}">
            <side-menu accordion ref="sideMenu" :active-name="$route.name" :collapsed="collapsed"
                       @on-select="turnToPage" :menu-list="sideMenuList">
                <!-- 需要放在菜单上面的内容，如Logo，写在side-menu标签内部，如下 -->
                <div class="logo-con">
                    <!--<img v-show="!collapsed" :src="minLogo" key="max-logo"/>-->
                    <img :src="minLogo" key="min-logo"/>
                    <p v-show="!collapsed">
                        非道路移动机械监管
                    </p>
                </div>
            </side-menu>
        </Sider>

        <Layout style="height:100%;">
            <Header class="header-con">
                <header-bar :collapsed="collapsed" @on-coll-change="handleCollapsedChange"
                            @on-select="(name)=>this.headerMenuActiveName=name"
                            :menu-list="headerMenuList">
                    <user :user-avatar="$store.getters.avatar"/>
                    <!--<fullscreen v-model="isFullscreen" style="margin-right: 10px;"/>-->
                </header-bar>
            </Header>

            <Content class="main-content-con">
                <Layout class="main-layout-con">
                    <div class="tag-nav-wrapper">
                        <tags-nav :value="$route" @input="handleClick" :list="tagNavList" @on-close="handleCloseTag"/>
                    </div>
                    <Content class="content-wrapper">
                        <router-view/>
                    </Content>
                </Layout>
            </Content>
        </Layout>
    </Layout>
</template>
<script>
    import SideMenu from '../components/side-menu'
    import HeaderBar from '../components/header-bar'
    import TagsNav from '../components/tags-nav'
    import User from '../components/user'
    import Fullscreen from '../components/fullscreen'
    import minLogo from '@/assets/images/logo-min.png'
    import maxLogo from '@/assets/images/logo.png'
    import customBreadCrumb from '../components/header-bar/custom-bread-crumb'
    import menu from '@/config/menu'
    import { mapMutations, mapActions, mapGetters } from 'vuex'
    import { getNewTagList, routeEqual } from '@/libs/util'
    import routers from '@/config/route'
    import './main.less'

    export default {
        name: 'Main',
        components: {
            SideMenu,
            HeaderBar,
            Fullscreen,
            User,
            customBreadCrumb,
            TagsNav
        },
        data() {
            return {
                collapsed: false,
                minLogo,
                maxLogo,
                isFullscreen: false,
                headerMenuActiveName: null,
                activeName: null,
            }
        },
        mounted() {
            this.activeName = this.getActiveName();
            this.setTagNavList()
            this.setHomeRoute(routers)
            const { name, params, query, meta } = this.$route
            this.addTag({
                route: { name, params, query, meta }
            })
            // 如果当前打开页面不在标签栏中，跳到homeName页
            if (!this.tagNavList.find(item => item.name === this.$route.name)) {
                this.$router.push({
                    name: this.$config.homeName
                })
            }
        },
        methods: {
            ...mapMutations([
                'setTagNavList',
                'addTag',
                'setLocal',
                'setHomeRoute',
                'closeTag'
            ]),
            // 获取子菜单
            getChildMenuByPid(pid, list) {
                return list.filter(e => e.parentId == pid && e.isMenu == 1).map(e => {
                    return {
                        ...e,
                        children: this.getChildMenuByPid(e.id, list)
                    };
                });
            },
            turnToPage(route) {
                //this.$router.push({name:route});
                if (_.isString(route)) {
                    route = this.$store.getters.auth.find(e => e.name === route);
                    if (!route) {
                        this.$Message.error('路由不存在');
                        return;
                    }
                    this.$router.push({name: route.name, query: route.params});
                    return;
                }
                const {name, params, query} = route;
                this.$router.push({name, params, query});
            },
            handleCollapsedChange(state) {
                this.collapsed = state
            },
            handleClick(item) {
                this.turnToPage(item)
            },
            getActiveName() {
                /*const {name, query} = this.$route;
                //let m = menu.find(e => e.name === name && JSON.stringify(e.params) === JSON.stringify(query));
                let m = this.findMenu(name, query, menu)
                return !!m ? m.name : '';*/

                const {name, query} = this.$route;
                let menu = this.$store.getters.auth.find(e => e.name === name);
                return !!menu ? menu.name : '';
            },
            findMenu(name, query, menu) {
                for (var i = 0; i < menu.length; i++) {
                    if (menu[i].name === name) {
                        return menu[i]
                    }
                    if (menu[i].children && menu[i].children.length > 0) {
                        let citem = this.findMenu(name, query, menu[i].children)
                        if (citem) {
                            return citem
                        }
                    }
                }
                return '';
            },
            filterMenu(menu) {
                return menu.map(e=>{
                    if (e.admin==0){
                        e.children = this.filterMenu(e.children)
                    }
                    return e
                }).filter(f=>f.admin==0)
            },
            handleCloseTag (res, type, route) {
                if (type !== 'others') {
                    if (type === 'all') {
                        this.turnToPage(this.$config.homeName)
                    } else {
                        if (routeEqual(this.$route, route)) {
                            this.closeTag(route)
                        }
                    }
                }
                this.setTagNavList(res)
            },
            handleClick (item) {
                this.turnToPage(item)
            }
        },
        computed: {
            // 头部主菜单
            headerMenuList() {
                return [];
            },
            // 侧边菜单
            sideMenuList() {
                /*if (this.$store.getters.isAdmin){
                    return menu;
                }
                return menu;*/

                return this.getChildMenuByPid(null, this.$store.getters.auth)
            },
            tagNavList () {
                return this.$store.state.app.tagNavList
            },
        },
        watch: {
            $route(to) {
                const {name, query, params, meta} = to;
                //this.activeName = this.getActiveName() || this.activeName;
                this.addTag({
                    route: { name, query, params, meta },
                    type: 'push'
                })
                this.setTagNavList(getNewTagList(this.tagNavList, to))
                this.$refs.sideMenu.updateOpenName(to.name)
            },
            headerMenuActiveName() {
                this.$refs.sideMenu.updateOpenName(this.$route.name);
            }
        },
    }
</script>
